<div artemisThemeSwitcher>
  <ng-container *ngIf="!isReset; else resetForm;">
    <mat-card class="forgot-password-card">
      <div class="go-back" routerLink="/login">
        <a>
          <img src="/assets/icons/arrow-left-icon.svg" class="go-back__img">
        </a>
        <span class="go-back__text">Go back</span>
      </div>
      <form (ngSubmit)="forgotPassword()" [formGroup]="forgotPasswordForm" class="forgot-password__form">
        <img src="/assets/images/logo-large.png" class="logo">
        <mat-card-title class="forgot-password-card__title">Forgot Password</mat-card-title>
        <mat-card-content class="forgot-password-card-content">
          <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory forgot-password__field">
            <input matInput type="email" placeholder="EMAIL" formControlName="username" autocomplete="email">
            <mat-error *ngIf="showFormControlErrors(forgotPasswordForm, 'username')">
              <span *ngIf="forgotPasswordForm.get('username').errors?.email">Invalid email format</span>
              <span *ngIf="forgotPasswordForm.get('username').errors?.required">Field is required</span>
            </mat-error>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions class="forgot-password-card__action">
          <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded btn-confirm" [disabled]="forgotPassword.invalid">
            Confirm
          </button>
        </mat-card-actions>
      </form>
    </mat-card>
  </ng-container>
  <ng-template #resetForm>
    <mat-card class="forgot-password-card">
      <div class="go-back" (click)="isReset = false">
        <img src="/assets/icons/arrow-left-icon.svg" class="go-back__img">
        <span class="go-back__text">Go back</span>
      </div>
      <form (ngSubmit)="resetPassword()" [formGroup]="resetPasswordForm" class="forgot-password__form">
        <img src="/assets/images/logo-large.png" class="logo">
        <mat-card-title class="forgot-password-card__title">Reset Password</mat-card-title>
        <mat-card-content class="forgot-password-card-content">
          <!-- Hidden fields to get full autocomplete browser functionality -->
          <input type="email" autocomplete="email" [value]="forgotPasswordForm.value.username" class="forgot-password__field_hidden">
          <!-- End hidden fields -->
          <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory forgot-password__field">
            <input type="text" matInput placeholder="CODE" formControlName="code" autocomplete="one-time-code">
            <mat-error *ngIf="showFormControlErrors(resetPasswordForm, 'code')">
              <span *ngIf="resetPasswordForm.get('code').errors?.required">Field is required</span>
              <span *ngIf="resetPasswordForm.get('code').errors?.pattern">{{ 'account_setting.errors' | translate }}</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory forgot-password__field">
            <input type="password" matInput placeholder="NEW PASSWORD" formControlName="newPassword" autocomplete="new-password">
            <mat-error *ngIf="showFormControlErrors(resetPasswordForm, 'newPassword')">
              <span *ngIf="resetPasswordForm.get('newPassword').errors?.required">Field is required</span>
              <span *ngIf="resetPasswordForm.get('newPassword').errors?.pattern">
                Must contain at least one number, one symbol, one uppercase, and lowercase letter, and at least 8 or more characters.
              </span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory forgot-password__field">
            <input type="password" matInput placeholder="REPEAT PASSWORD" formControlName="confirmNewPassword" autocomplete="new-password">
            <mat-error *ngIf="showFormControlErrors(resetPasswordForm, 'confirmNewPassword')">
              <span *ngIf="resetPasswordForm.get('confirmNewPassword').errors?.required">Field is required</span>
              <span *ngIf="resetPasswordForm.get('confirmNewPassword').errors?.pattern">
                Must contain at least one number, one symbol, one uppercase, and lowercase letter, and at least 8 or more characters.
              </span>
            </mat-error>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions class="forgot-password-card__action">
          <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded btn-reset" [disabled]="resetPasswordForm.invalid">
            Reset
          </button>
        </mat-card-actions>
      </form>
    </mat-card>
  </ng-template>
</div>
<div class="copyright">
  <span>Copyright © 2019 Cynopsis Solutions Pte. Ltd.</span>
  <span>All Rights Reserved</span>
</div>
